import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { mobileDeviceFullStore } from '../store/store';
import { Label } from 'office-ui-fabric-react/lib/Label';
import strings from 'owa-strings/owa-options-strings';
var MobileDeviceLogging = /** @class */ (function (_super) {
    tslib_1.__extends(MobileDeviceLogging, _super);
    function MobileDeviceLogging() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MobileDeviceLogging.prototype.render = function () {
        return (React.createElement("div", null, mobileDeviceFullStore().isLoggingEnabled ? (React.createElement(Label, null, strings.options_mobile_logging_enableLabel)) : (React.createElement(Label, null, strings.options_mobile_logging_disableLabel))));
    };
    MobileDeviceLogging = tslib_1.__decorate([
        observer
    ], MobileDeviceLogging);
    return MobileDeviceLogging;
}(React.Component));
export default MobileDeviceLogging;
//# sourceMappingURL=MobileDeviceLogging.js.map